var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,99l10.79-16.47m-43.15,6.82,17.88,13.06m-46.29,2.84,12.61-13.6m70.88-18.49a9.09,9.09,0,1,1-9.08-9.08A9.09,9.09,0,0,1,157.61,73.18ZM77.26,112.94a9.08,9.08,0,1,1-9.08-9.09A9.09,9.09,0,0,1,77.26,112.94Zm60.48-6.53a9.09,9.09,0,1,1-9.09-9.09A9.09,9.09,0,0,1,137.74,106.41ZM103.1,86.24A9.09,9.09,0,1,1,94,77.16,9.09,9.09,0,0,1,103.1,86.24Zm3.69-40V37.13m0,143.94V141m48,46.85-21.86-46.57M59.67,187.89l21.85-46.57m101.11-.21H33.31V46.53H182.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/PRESENTATION.5366f0c8f302473db590fcce4703188b.svg";
export { ForwardRef as ReactComponent };